// extracted by mini-css-extract-plugin
export default {"content_list":"XwKD","button":"_3Lds","panel_link":"H6Zb","sidebar_comments_length":"_2p7M","sidebar_comments_max_length":"_2jWZ"};